import React, {useEffect, useRef, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { IMAGE_GEEKO_LTD } from '../../../../../constants'
import { Iconfont } from '../../../../components/icon/iconfont'
import { useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import MeLoading from '../../components/loading'
import { postHeaderImage } from '../../../../../api'
import Toast from '../../../../components/toast'
import _ from 'lodash'
import { useIntl } from 'react-intl'

const ChangeProfilePicture = props => {
    useStyles(classes)
    const {baseHeaderUrl, userHeaderUrl, headerImageHandle, Intl} = props
    const uploadImageForm = useRef()

    return (
        <div className={`${classes.EditBlock} ${classes.EditPadding} ${classes.ChangeProfilePicture}`}>
            <div className={classes.Title}>
                {Intl.formatMessage({id: 'change_profile_picture'})}
            </div>
            <div>
                <div className={classes.EditImage} style={{backgroundImage: `${userHeaderUrl?`url(${userHeaderUrl}), url(${baseHeaderUrl})`:`url(${baseHeaderUrl})`}`}}></div>
                <form ref={uploadImageForm}>
                    <input name="imageFile" className={classes.UploadImage} type="file" onChange={(e) => headerImageHandle(e, uploadImageForm.current)}/>
                </form>
            </div>
            <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
        </div>
    )
}

const ChangeName = props => {
    useStyles(classes)
    const { userName, nickName, bio, goTo, Intl } = props

    return (
        <React.Fragment>
            <div className={`${classes.EditBlock} ${classes.ChangeNameItem}`} onClick={() => goTo('/user/set-name')}>
                <div className={classes.Title}>
                    {Intl.formatMessage({id: 'name'})}
                </div>
                <div className={classes.UserInfoBox}>
                    {
                        userName ?
                        <span>{userName}</span>:
                        <span className={classes.Tip}></span>
                    }
                </div>
                <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
            </div>

            <div className={`${classes.EditBlock} ${classes.ChangeNameItem}`} onClick={() => goTo('/user/set-nick-name')}>
                <div className={classes.Title}>
                    {Intl.formatMessage({id: 'nick_name'})}
                </div>
                <div className={classes.UserInfoBox}>
                    {
                        nickName ?
                        <span>{nickName}</span>:
                        <span className={classes.Tip}></span>
                    }
                </div>
                <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
            </div>

            <div className={`${classes.EditBlock} ${classes.EditPadding} ${classes.ChangeNameItem}`} onClick={() => goTo('/user/set-bio')}>
                <div className={classes.Title}>
                    {Intl.formatMessage({id: 'bio'})}
                </div>
                <div className={classes.UserInfoBox}>
                    {
                        bio ?
                        <span>{bio}</span>:
                        <span className={classes.Tip}></span>
                    }
                </div>
                <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
            </div>
        </React.Fragment>
    )
}

const ChangeMeasurement = props => {
    useStyles(classes)
    const { goTo, userPerference, Intl } = props
    const [list, setList] = useState([])
    
    useEffect(() => {
        if(userPerference?.length > 0){
            setList(userPerference?.slice(0,3))
        }
    }, [userPerference])

    return (
        <React.Fragment>
            <div className={`${classes.EditBlock} ${classes.ChangeMeasurement}`} onClick={() => goTo('/user/my-preference')}>
                <div className={`${classes.Title} ${classes.PerferenceTitle}`}>
                {Intl.formatMessage({id: 'my_preference'})}
                </div>
                <div className={classes.PerferenceList}>
                    {
                        list?.map((item, index) => (
                            <span key={item?.label+index} className={classes.PerferenceItem}>{item?.label || ''}</span>
                        ))
                    }
                    {
                        userPerference?.length > 3 &&
                        <span style={{marginLeft: 3}}>...</span>
                    }
                </div>
                <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
            </div>

            <div className={`${classes.EditBlock} ${classes.ChangeMeasurement}`} onClick={() => goTo('/user/my-measurements')}>
                <div className={classes.Title}>{Intl.formatMessage({id: 'my_measurements'})}</div>
                <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
            </div>
        </React.Fragment>
    )

}

const EditProfile = props => {
    useStyles(classes)

    const [loading, setLoading] = useState(true)
    const [userHeaderUrl, setUserHeaderUrl] = useState('')
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const global = useSelector(state => state.global);
    const pageCustomer = useSelector(state => state.pageCustomer)
    const {customer} = pageCustomer
    const history = useHistory()
    const Intl = useIntl()

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await EditProfile.fetchData(store, params, query)
		}
    }, [customer?.id])

    useEffect(() => {
        if(customer?.id){
            setLoading(false)
            setUserHeaderUrl(`https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/icon/${customer.id}?icon=${new Date().getTime()}`)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[customer])

    const baseHeaderUrl = useMemo(() =>{
        let imageUrl;
        if (global?.shortName === 'chicme') {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/icon.png`;
        } else if (global?.shortName === 'ivrose') {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/iv.png`;
        } else {
            imageUrl = `${IMAGE_GEEKO_LTD}/chicme/20210813/bq.png`;
        }

        return imageUrl;
    }, [global?.shortName]);

    const userName = useMemo(() =>{
        return (customer?.name?.firstName || '') + ' ' + (customer?.name?.lastName || '');
    }, [customer?.name]);

    const userPerference = useMemo(() => {
        const returnArr = (arr) => {
            return arr && arr.length > 0 ? arr : [];
        }
        if(customer?.myPreference){
            let arr = _.concat(
                returnArr(customer?.myPreference?.favoriteCategories),
                returnArr(customer?.myPreference?.favoriteStyles),
                returnArr(customer?.myPreference?.usuallyBuyClothesFor),
                )
            return arr
        }

    }, [customer?.myPreference])

    const headerImageHandle = (e, ref) => {
        setLoading(true)
        let files = e?.target?.files, file = files[0];
        if(file?.size > 2048000){
            Toast(Intl.formatMessage({id:'upload_file_size_limit',defaultMessage:"File size must under 2MB"}))
            setLoading(false)
            return
        }
        let src = window.navigator.userAgent.indexOf("Chrome") >= 1 || window.navigator.userAgent.indexOf("Safari") >= 1 ? 
                  window.webkitURL.createObjectURL(file) :
                  window.URL.createObjectURL(file);
        let formData = new FormData(ref)
        postHeaderImage(formData, {'Content-Type':'multipart/form-data'})
        .then(res => {
            setLoading(false)
            if(res?.code == 200){
                Toast("Success!")
                setUserHeaderUrl(src)
            } else {
                alert(res?.result || res)
            }
        }).catch(err => {
            setLoading(false)
            alert(err?.result || err)
        })
    }

    const goTo = (url) => {
        history.push(url)
    }

    return (
        <div className={classes.EditProfile}>
            <MeChildHeader name={Intl.formatMessage({id: 'edit_profile'})}/>

            <ChangeProfilePicture
                baseHeaderUrl={baseHeaderUrl}
                userHeaderUrl={userHeaderUrl}
                headerImageHandle={(e, ref) => headerImageHandle(e, ref)}
                Intl={Intl}
                />

            <ChangeName
                userName={userName}
                nickName={customer?.nickname}
                bio={customer?.bio}
                goTo={(e) => goTo(e)}
                Intl={Intl}
                />

            <ChangeMeasurement
                userPerference={userPerference}
                goTo={(e) => goTo(e)}
                Intl={Intl}
                />

            <MeLoading loading={loading} />
        </div>
    )
}

EditProfile.fetchData = async (store, params, search, headers) => {
}

export default EditProfile
